/* global axios */
import ApiClient from '../ApiClient';

class CaptainLlmCredentials extends ApiClient {
  constructor() {
    super('captain/llm_credentials', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(data = {}) {
    return axios.post(this.url, { llm_credential: data });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, { llm_credential: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Tries a key (and endpoint) before it is saved; `id` makes a blank key mean the stored one.
  check({ id, ...data } = {}) {
    return axios.post(`${this.url}/check`, { id, llm_credential: data });
  }
}

export default new CaptainLlmCredentials();
